import { useEffect, useState } from "react";

const TICK_MS = 30_000;

const formatDuration = (ms: number): string => {
	const totalMinutes = Math.floor(ms / 60_000);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m`;
};

export function useElapsedDuration(startMs: number | null): string | null {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		if (!startMs) return;
		const interval = setInterval(() => setNow(Date.now()), TICK_MS);
		return () => clearInterval(interval);
	}, [startMs]);

	if (!startMs) return null;

	return formatDuration(Math.max(0, now - startMs));
}
